/**
 * Cookie utility helpers.
 * Authentication cookies are managed by the backend (HttpOnly).
 */

// Set a secure cookie
export const setSecureCookie = (name, value, options = {}) => {
  const defaultOptions = {
    path: '/',
    secure: true, // Only send over HTTPS
    sameSite: 'strict', // Protect against CSRF
    httpOnly: false, // Will be true when backend supports it
    maxAge: 60 * 60 * 24 * 7, // 7 days default
    ...options
  };

  let cookieString = `${name}=${encodeURIComponent(value)}`;
  
  if (defaultOptions.path) cookieString += `; path=${defaultOptions.path}`;
  if (defaultOptions.domain) cookieString += `; domain=${defaultOptions.domain}`;
  if (defaultOptions.maxAge) cookieString += `; max-age=${defaultOptions.maxAge}`;
  if (defaultOptions.secure) cookieString += '; secure';
  if (defaultOptions.sameSite) cookieString += `; samesite=${defaultOptions.sameSite}`;
  
  document.cookie = cookieString;
};

// Get a cookie value
export const getCookie = (name) => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.trim().split('=');
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
};

// Delete a cookie
export const deleteCookie = (name, options = {}) => {
  const defaultOptions = {
    path: '/',
    domain: options.domain,
    ...options
  };
  
  setSecureCookie(name, '', { ...defaultOptions, maxAge: -1 });
};

// Check if cookies are supported
export const areCookiesSupported = () => {
  try {
    document.cookie = 'test=1';
    const supported = document.cookie.indexOf('test=') !== -1;
    document.cookie = 'test=1; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    return supported;
  } catch (e) {
    return false;
  }
};

export const getCsrfToken = () => getCookie('csrf_token');
